import React, { useState } from "react";
import "./App.css";
import { bodys, necks, heads } from "./assets";
import { ReactComponent as HeadIcon } from "./assets/icon-head.svg";
import { ReactComponent as NeckIcon } from "./assets/icon-neck.svg";
import { ReactComponent as BodyIcon } from "./assets/icon-body.svg";
import { ReactComponent as AllIcon } from "./assets/icon-all.svg";
import { isMobile } from "react-device-detect";

const allColors = [
  { color: "ffffff", label: "White" },
  { color: "000000", label: "Black" },
  { color: "c8ç1b7", label: "Gray" },
  { color: "86ca99", label: "Apple Mint" },
  { color: "e57035", label: "Carrot" },
  { color: "de8c9b", label: "Pink" },
  { color: "ca8abc", label: "Purple" },
  { color: "f1b931", label: "Yellow" },
];

const colors = [
  { color: "ffffff", label: "White" },
  { color: "000000", label: "Black" },
  { color: "c8ç1b7", label: "Gray" },
  { color: "86ca99", label: "Apple Mint" },
  { color: "e57035", label: "Carrot" },
  { color: "de8c9b", label: "Pink" },
  { color: "ca8abc", label: "Purple" },
  { color: "f1b931", label: "Yellow" },
  { color: "a6c184", label: "Olive" },
  { color: "6c9ea9", label: "Hawaiian Blue" },
  { color: "c35656", label: "Burgundy" },
];

function App() {
  const [unitColor, setUnitColor] = useState<{
    head: number;
    neck: number;
    body: number;
  }>({
    head: 0,
    neck: 0,
    body: 0,
  });

  const [tab, setTab] = useState<"head" | "neck" | "body">("head");

  const handleClickTab = (tab: "head" | "neck" | "body") => () => {
    setTab(tab);
  };

  const handleClickColor = (name: string, index: number) => () => {
    setUnitColor({ ...unitColor, [name]: index });
  };

  const handleClickAllColors = (index: number) => () => {
    let all = [heads[index], necks[index], bodys[index]];
    all.forEach((image) => {
      new Image().src = image;
    });
    setTimeout(() => {
      setUnitColor({
        head: index,
        neck: index,
        body: index,
      });
    }, 100);
  };

  return (
    <div className="wrapper">
      <img
        src="https://aquaduo.co.kr/web/upload/NNEditor/20200318/ec3ad143c0d1da76ace3d05d90e67ffc.png"
        className="logo"
        alt="logo"
      />

      <div className="content">
        <div className="image-box">
          <img src={heads[unitColor.head]} className="image-head" alt="head" />
          <img src={necks[unitColor.neck]} className="image-neck" alt="neck" />
          <img src={bodys[unitColor.body]} className="image-body" alt="body" />
        </div>
      </div>
      <p className="label-wrapper">
        <AllIcon />
        ALL
      </p>

      <div className="button-wrapper">
        {allColors.map((color, index) => (
          <div className="button-inner-wrapper">
            <button
              key={`${color.color}-neck`}
              onClick={handleClickAllColors(index)}
              className={`
              ${color.label === "White" ? "color-button-white" : "color-button"}
              color-${color.color}`}
            />
            <p className="button-label">{color.label}</p>
          </div>
        ))}
      </div>
      <hr className="divider" />
      <div className="tab-wrapper">
        <div
          className={`tab ${tab === "head" && "select"}`}
          onClick={handleClickTab("head")}
        >
          <NeckIcon />
          Head cap
        </div>
        <div
          className={`tab ${tab === "neck" && "select"}`}
          onClick={handleClickTab("neck")}
        >
          <HeadIcon />
          Head
        </div>
        <div
          className={`tab ${tab === "body" && "select"}`}
          onClick={handleClickTab("body")}
        >
          <BodyIcon />
          Body
        </div>
      </div>
      <div className="button-wrapper">
        {colors.map((color, index) => (
          <div className="button-inner-wrapper">
            <button
              key={`${color.color}-neck`}
              onClick={handleClickColor(tab, index)}
              className={`
              ${color.label === "White" ? "color-button-white" : "color-button"}
              color-${color.color}`}
            />
            <p className="button-label">{color.label}</p>
          </div>
        ))}
      </div>
      <hr className="divider" />
      <footer className="footer">
        <button className="linked-button">
          <a
            href={
              isMobile
                ? "https://m.aquaduo.co.kr/product/detail.html?product_no=157&cate_no=43&display_group=1#enp_mbris"
                : "https://aquaduo.co.kr/product/detail.html?product_no=157&cate_no=43&display_group=1#enp_mbris"
            }
            className="link"
          >
            buy it!
          </a>
        </button>
      </footer>
    </div>
  );
}

export default App;
